import {Component, OnInit} from '@angular/core';
import {MercadoriasVariedadesService} from "./mercadorias-variedades.service";
import {MercadoriasVariedadesModel} from "./mercadorias-variedades.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {TranslateService} from '@ngx-translate/core';
import {LoginService} from "../login/login.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MercadoriasService} from "../mercadorias/mercadorias.service";

declare let swal, $: any;

@Component({
  selector: 'app-mercadorias-variedades',
  templateUrl: './mercadorias-variedades.component.html'
})
export class MercadoriasVariedadesComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"nome":"", "mercadoria":""};

  variedades: MercadoriasVariedadesModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listMercadorias = [];

  constructor(
    formBuilder: FormBuilder,
    private mercadoriasVariedadesService: MercadoriasVariedadesService,
    private mercadoriasService: MercadoriasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'mercadorias'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      nome: [],
      mercadoria: []
    });

    this.mercadoriasService.get(null, null, ['id', 'nome_pt'])
      .subscribe(
        json => {
          this.listMercadorias = json.Payload;
        },
        error => {
          this.func.showErro(error.json());
        });
  }

  ngOnInit() {
    this.getPage(1);
  }

  delete(mercadoria) {
    let variedades = this.variedades;
    let mercadoriasVariedadesService = this.mercadoriasVariedadesService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarMercadoria')+mercadoria.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(variedades);
        }

        let index = variedades.indexOf(mercadoria);
        variedades.splice(index, 1);

        mercadoriasVariedadesService.apagar(mercadoria.id)
          .subscribe(res => {
              self.variedades = variedades;
            },
            err => {
              // Revert the view back to its original state
              variedades.splice(index, 0, mercadoria);
              self.variedades = variedades;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};

    if(this.filtroPesquisa.nome != ''){
      filtros['nome'] = '**:'+this.filtroPesquisa.nome;
    }

    if(this.filtroPesquisa.mercadoria != ''){
      filtros['id_mercadoria'] = this.filtroPesquisa.mercadoria;
    }

    this.mercadoriasVariedadesService.getPaginacao(pagina,this.itensPorPagina, ["mercadoria"], filtros)
      .subscribe(data => {
        this.variedades = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"nome":"", "mercadoria":""};
  }

}



// WEBPACK FOOTER //
// ./src/app/mercadorias-variedades/mercadorias-variedades.component.ts